import React, {useCallback, useEffect, useRef, useState} from 'react';
import Form, {ButtonItem, GroupItem, RequiredRule, SimpleItem} from "devextreme-react/form";
import {useHistory} from 'react-router-dom';
import {useSnackbar} from 'notistack';
import {buttonSuccess} from "../../../../../utils/ComponentsSetting";
import {Button} from "devextreme-react/button";
import {ErrorMessage, NotiStackInfo} from "../../../../../palette/NotiStackInfo";
import {db} from '../../../../../firebase/Firebase';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';
import format from 'date-fns/format';
import {FilterDelete, Filters} from "../../../../../utils/HelpFunctions";
import Alerts from "../../../../../palette/Alerts";
import difference from 'date-fns/differenceInMinutes'
import {es} from 'date-fns/locale'

const now = new Date();


const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function ChoiceDriver(props) {

    const {DataStore, setDataExpress, dataExpress, setValueDate, valueDate} = props

    const {companyName, idCompany, triggerEffect} = DataStore

    const data = {
        date: null,
        driver: '',
        total: null,
        details: '',
    }


    const {enqueueSnackbar} = useSnackbar();

    const [submitButton] = useState({...buttonSuccess, text: 'Aceptar'})
    const [strDate, setStrDate] = useState('');
    const [drivers, setDrivers] = useState([]);
    const [driversList, setDriversList] = useState(null);
    const [driversData, setDriversData] = useState(null);
    const [textAlert, setTextAlert] = useState('')
    const [severity, setSeverity] = useState('warning')
    const [visible, setVisible] = useState(false)
    const [dataForm, setDataForm] =useState(data)

    const dxForm = useRef(null);
    let history = useHistory();
    const isMounted = useMountedState()

    useEffect(() => {
        const {instance} = dxForm.current
        instance.resetValues()
        setDriversData(null)
        setDataForm(data)
    }, [dataExpress, triggerEffect])

    const mainPath = db.collection(companyName).doc(idCompany)

    useEffect(() => {
        const GetDrivers = async () => {
            const newArray = [];
            await mainPath.collection('DriverManagement')
                .where('state', '==', 'Activo')
                .get().then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        const obj = {
                            ...doc.data(),
                            docId: doc.id,
                            completeName: `${doc.data().name} ${doc.data().lastName}`,
                        };
                        newArray.push(obj);
                    });
                    setDrivers([...newArray]);
                });
        };

        if (isMounted) {
            GetDrivers().catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                history.push('/control-panel/passengers-managements');
            });
        }

    }, [companyName, enqueueSnackbar, history, idCompany, isMounted]);

    const renderCancelButton = () => {
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => {
                        history.push('/control-panel/passengers-managements')
                    }}/>
        )
    }

    const onValueChanged = async (e) => {
        if (e.value) {
            setDataExpress(null)
            setVisible(false)
            const year = format(e.value, 'yyyy');
            const month = format(e.value, 'MMMM', {locale: es});
            const date = format(e.value, 'yyyy-MM-dd');

            const driversIds = []
            await mainPath.collection('Reservations').doc(year).collection(month)
                .where('date', '==', date).get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        driversIds.push(doc.data().driverId)
                    });
                });

            let driverList = [...drivers]
            driversIds.forEach(id => {
                driverList = FilterDelete(driverList, 'docId', id)
            })

            if (driverList.length === 0) {
                setTextAlert('No existen conductores disponibles')
                setDriversList(driverList)
                return
            }
            setDriversList(driverList)
            setValueDate(e.value);
            setVisible(true)
            setStrDate(format(e.value, 'yyyy-MM-dd HH:mm'));
        }
    };

    const renderAlert = () => {
        return (
            <Alerts severity={severity} body={textAlert}/>
        )
    }

    const onValueDriver = (e) => {
        const driver = Filters(drivers, 'docId', e.value);
        setDriversData(driver)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setVisible(false)
        setDataExpress({...dataForm, valueDate: valueDate, strDate: strDate, driversData: driversData})
    }


    return (
        <>
            <form action="" onSubmit={handleSubmit}>
                <Form
                    ref={dxForm}
                    formData={dataForm}
                    readOnly={false}
                    showColonAfterLabel={true}
                    validationGroup="express"
                >
                    <GroupItem colCount={1}>
                        <SimpleItem dataField="date" label={{text: 'Fecha y hora'}} editorType="dxDateBox"
                                    editorOptions={{
                                        type: 'datetime',
                                        showAnalogClock: true,
                                        placeholder: 'Seleccionar...',
                                        onValueChanged: onValueChanged,
                                        min: format(new Date(), 'yyyy-MM-dd')
                                        //value: valueDate
                                    }}>
                            <RequiredRule message="Seleccione la fecha y la hora"/>
                        </SimpleItem>

                        {driversList?.length === 0 && <SimpleItem render={renderAlert}/>}

                        {(driversList?.length > 0 && visible) &&
                        <GroupItem colCount={1}>
                            <SimpleItem dataField="driver" label={{text: 'Conductor'}}
                                        editorType="dxSelectBox"
                                        editorOptions={{
                                            dataSource: driversList,
                                            searchEnabled: true,
                                            valueExpr: "docId",
                                            displayExpr: "completeName",
                                            placeholder: 'Seleccionar...',
                                            onValueChanged: onValueDriver
                                        }}>
                                <RequiredRule message="Seleccione el conductor"/>
                            </SimpleItem>
                            <SimpleItem dataField="total" label={{text: 'Tarifa express'}} editorType="dxNumberBox"
                                        editorOptions={{format: "$ #0.##", defaultValue: null}}>
                                <RequiredRule message="Ingrese la tarifa"/>
                            </SimpleItem>
                            <SimpleItem dataField="details" editorType="dxTextArea" editorOptions={{height: 90}}
                                        label={{text: 'Detalles'}}/>

                            {visible &&
                            <GroupItem colCount={2}>
                                <SimpleItem render={renderCancelButton}/>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </GroupItem>}
                        </GroupItem>}

                        {driversList?.length === 0 && <SimpleItem render={renderCancelButton}/>}
                    </GroupItem>
                </Form>
            </form>

        </>
    )

}

export default ChoiceDriver